<div class="flex flex-col h-full">
  <app-header>
    <div class="flex items-center">
      <button mat-icon-button (click)="goBack()" matTooltip="Ga terug">
        <mat-icon>arrow_back</mat-icon>
      </button>
      @if (currentUnit(); as unit) {
        <span
          class="truncate max-w-30 text-base font-medium text-gray-800"
          [matTooltip]="unit.name"
          >{{ unit.name }}</span
        >
      }
    </div>
  </app-header>
  @if (showPlaceholder() && user.data(); as userData) {
    <app-empty-state-placeholder
      class="max-w-xl m-auto"
      icon="deployed_code"
      heading="Je hebt nog geen units"
      message="Met units kun je je organisatie opdelen in afdelingen, teams of vestigingen. Voeg een unit toe om te starten."
    >
      <button
        *appHasPermission="'unit:create'"
        mat-flat-button
        ngProjectAs="button"
        (click)="addUnit(userData.unitId, 'bottom')"
      >
        <mat-icon>add</mat-icon>

        Unit toevoegen
      </button>
    </app-empty-state-placeholder>
  } @else {
    <app-tree-view [nodes]="treeNodes()" [rootId]="user.data()?.rootUnitId" #treeView>
      <ng-template #rootTemplate let-node>
        @let unit = getUnitById(node.id);
        <app-unit-card
          [data]="unit"
          [active]="unit._id === user.data()?.unitId"
          [main]="true"
          [dimmed]="isUnitDimmed(unit._id)"
          [highlighted]="isUnitHighlighted(unit._id)"
          (activate)="activateUnit($event)"
          (addUnit)="addUnit(unit._id, $event)"
        />
      </ng-template>
      <ng-template #nodeTemplate let-node>
        @let unit = getUnitById(node.id);
        <app-unit-card
          [data]="unit"
          [active]="unit._id === user.data()?.unitId"
          [disabled]="!!unit.deleteAt"
          [dimmed]="isUnitDimmed(unit._id)"
          [highlighted]="isUnitHighlighted(unit._id)"
          (activate)="activateUnit($event)"
          (addUnit)="addUnit(unit._id, $event)"
          (restore)="restoreUnit($event)"
        />
      </ng-template>
    </app-tree-view>

    <!-- Search panel (floating above controls) -->
    @if (searchPanelOpen()) {
      <div
        class="absolute left-4 bottom-16 z-10"
        (dblclick)="$event.stopPropagation()"
        (wheel)="$event.stopPropagation()"
      >
        <app-unit-search
          [units]="units()"
          [canReadDevices]="canReadDevices()"
          [canReadClients]="canReadClients()"
          (matchingUnitIdsChange)="onMatchingUnitIds($event)"
          (focusUnit)="onFocusUnit($event)"
          (navigateToUnit)="onNavigateToUnit($event)"
          (navigateToDevice)="onNavigateToDevice($event)"
          (navigateToClient)="onNavigateToClient($event)"
          (close)="closeSearch()"
        />
      </div>
    }

    <div
      class="flex items-center absolute inset-x-4 bottom-4 gap-2"
      (dblclick)="$event.stopPropagation()"
      (wheel)="$event.stopPropagation()"
    >
      <!-- Search button -->
      <div class="flex items-center rounded-lg bg-white border border-gray-200 shadow-md overflow-hidden">
        <button
          class="size-9 text-base/9 rounded-lg hover:cursor-pointer hover:bg-gray-100"
          [class.bg-gray-200]="searchPanelOpen()"
          type="button"
          (click)="toggleSearch()"
          matTooltip="Zoeken & filteren"
          matTooltipPosition="above"
        >
          <mat-icon inline>search</mat-icon>
        </button>
      </div>

      <div class="flex items-center rounded-lg bg-white border border-gray-200 shadow-md overflow-hidden">
        <button
          class="size-9 text-base/9 rounded-lg hover:cursor-pointer hover:bg-gray-100"
          type="button"
          (click)="treeView.fitBounds()"
          matTooltip="Passend maken"
          matTooltipPosition="above"
        >
          <mat-icon inline>fullscreen</mat-icon>
        </button>
      </div>

      <div class="flex items-center rounded-lg bg-white border border-gray-200 shadow-md overflow-hidden">
        <button
          class="size-9 text-base/9 hover:cursor-pointer hover:bg-gray-100"
          type="button"
          (click)="treeView.zoomOut()"
          matTooltip="Uitzoomen"
          matTooltipPosition="above"
        >
          <mat-icon inline>remove</mat-icon>
        </button>
        <button
          class="w-15 h-9 px-2 text-sm hover:cursor-pointer hover:bg-gray-100"
          type="button"
          (click)="treeView.resetZoom()"
          matTooltip="Zoom resetten"
          matTooltipPosition="above"
        >
          {{ treeView.currentScale() * 100 | round }}%
        </button>
        <button
          class="size-9 text-base/9 hover:cursor-pointer hover:bg-gray-100"
          type="button"
          (click)="treeView.zoomIn()"
          matTooltip="Inzoomen"
          matTooltipPosition="above"
        >
          <mat-icon inline>add</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
